import {isEmpty} from "lodash";

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

class PromiseBuilder {
  constructor() {
    this._tasks = [];
    this._errorTask = undefined;
    this._finallyTask = undefined;
  }

  then(task, minimumTimeout = 0) {
    this._tasks.push({task: task, minimumTimeout: minimumTimeout})
    return this;
  }

  catch(errorTask) {
    this._errorTask = errorTask;
    return this;
  }

  finally(finalizeTask) {
    this._finallyTask = finalizeTask;
    return this;
  }

  _processNextTask(previousResponse = undefined) {
    if (isEmpty(this._tasks)) {
      this._finallyTask && this._finallyTask();
      return;
    }
    const {task, minimumTimeout} = this._tasks.pop();
    Promise.all([task(previousResponse), wait(minimumTimeout)])
      .then(([response]) => this._processNextTask(response))
      .catch(reason => {
        this._errorTask && this._errorTask(reason);
        this._finallyTask && this._finallyTask();
      });
  }

  run() {
    this._tasks.reverse();

    this._processNextTask();
  }
}

export default PromiseBuilder;
